import type { PreferredSignInProvider } from "@/lib/auth/preferred-sign-in-provider";

export type LoginProviderSlot = PreferredSignInProvider;

export type ResolvedLoginProviders = {
  primary: LoginProviderSlot;
  accordion: LoginProviderSlot[];
};

type ResolveLoginProvidersParams = {
  preferred?: PreferredSignInProvider | null;
  qaLoginEnabled?: boolean;
  includeQa?: boolean;
};

function withQaLogin(
  slots: LoginProviderSlot[],
  qaLoginEnabled: boolean
): LoginProviderSlot[] {
  if (!qaLoginEnabled) {
    return slots.filter((slot) => slot !== "qa-login");
  }

  return slots;
}

export function resolveLoginProviders({
  preferred,
  qaLoginEnabled = false,
  includeQa = true,
}: ResolveLoginProvidersParams): ResolvedLoginProviders {
  const qaEnabled = includeQa && qaLoginEnabled;
  const effectivePreferred =
    !includeQa && preferred === "qa-login" ? null : preferred;

  switch (effectivePreferred) {
    case "email":
      return {
        primary: "email",
        accordion: withQaLogin(["google", "qa-login"], qaEnabled),
      };
    case "qa-login":
      return {
        primary: "qa-login",
        accordion: withQaLogin(["google", "email"], qaEnabled),
      };
    default:
      return {
        primary: "google",
        accordion: withQaLogin(["email", "qa-login"], qaEnabled),
      };
  }
}
